'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var log = Object.assign(debug('libp2p:persistent-peer-store'), {
  error: debug('libp2p:persistent-peer-store:err')
});

var _require = require('interface-datastore/key'),
    Key = _require.Key;

var _require2 = require('multiaddr'),
    Multiaddr = _require2.Multiaddr;

var PeerId = require('peer-id');

var _require3 = require('multiformats/bases/base32'),
    base32 = _require3.base32;

var PeerStore = require('..');

var _require4 = require('./consts'),
    NAMESPACE_ADDRESS = _require4.NAMESPACE_ADDRESS,
    NAMESPACE_COMMON = _require4.NAMESPACE_COMMON,
    NAMESPACE_KEYS = _require4.NAMESPACE_KEYS,
    NAMESPACE_METADATA = _require4.NAMESPACE_METADATA,
    NAMESPACE_PROTOCOL = _require4.NAMESPACE_PROTOCOL;

var _require5 = require('./pb/address-book'),
    Addresses = _require5.Addresses;

var _require6 = require('./pb/proto-book'),
    Protocols = _require6.Protocols;
/**
 * @typedef {import('interface-datastore').Batch} Batch
 * @typedef {import('../address-book.js').Address} Address
 */

/**
 * @typedef {Object} PersistentPeerStoreProperties
 * @property {PeerId} peerId
 * @property {import('interface-datastore').Datastore} datastore
 *
 * @typedef {Object} PersistentPeerStoreOptions
 * @property {number} [threshold = 5] - Number of dirty peers allowed before commit data.
 */

/**
 * Responsible for managing the persistence of data in the PeerStore.
 */


var PersistentPeerStore = /*#__PURE__*/function (_PeerStore) {
  _inherits(PersistentPeerStore, _PeerStore);

  var _super = _createSuper(PersistentPeerStore);

  /**
   * @class
   * @param {PersistentPeerStoreProperties & PersistentPeerStoreOptions} properties
   */
  function PersistentPeerStore(_ref) {
    var _this;

    var peerId = _ref.peerId,
        datastore = _ref.datastore,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === void 0 ? 5 : _ref$threshold;

    _classCallCheck(this, PersistentPeerStore);

    _this = _super.call(this, {
      peerId: peerId
    });
    /**
     * Backend datastore used to persist data.
     */

    _this._datastore = datastore;
    /**
     * Peers modified after the latest data persisted.
     */

    _this._dirtyPeers = new Set();
    /**
     * Peers metadata changed mapping peer identifers to metadata changed.
     *
     * @type {Map<string, Set<string>>}
     */

    _this._dirtyMetadata = new Map();
    _this.threshold = threshold;
    _this._addDirtyPeer = _this._addDirtyPeer.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Start Persistent PeerStore.
   *
   * @returns {Promise<void>}
   */


  _createClass(PersistentPeerStore, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('PeerStore is starting'); // Handlers for dirty peers

                this.on('change:protocols', this._addDirtyPeer);
                this.on('change:multiaddrs', this._addDirtyPeer);
                this.on('change:pubkey', this._addDirtyPeerKey);
                this.on('change:metadata', this._addDirtyPeerMetadata); // Load data

                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 7;
                _iterator = _asyncIterator(this._datastore.query({
                  prefix: NAMESPACE_COMMON
                }));

              case 9:
                _context.next = 11;
                return _iterator.next();

              case 11:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 18;
                  break;
                }

                entry = _step.value;
                _context.next = 15;
                return this._processDatastoreEntry(entry);

              case 15:
                _iteratorAbruptCompletion = false;
                _context.next = 9;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 29;
                  break;
                }

                _context.next = 29;
                return _iterator.return();

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(24);

              case 34:
                log('PeerStore started');

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 20, 24, 34], [25,, 29, 33]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Stop Persistent PeerStore.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                log('PeerStore is stopping');
                this.removeAllListeners();
                _context2.next = 4;
                return this._commitData();

              case 4:
                log('PeerStore stopped');

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * Add modified peer to the dirty set
     *
     * @private
     * @param {Object} params
     * @param {PeerId} params.peerId
     */

  }, {
    key: "_addDirtyPeer",
    value: function _addDirtyPeer(_ref2) {
      var peerId = _ref2.peerId;
      var peerIdstr = peerId.toB58String();
      log('add dirty peer', peerIdstr);

      this._dirtyPeers.add(peerIdstr);

      if (this._dirtyPeers.size >= this.threshold) {
        // Commit current data
        this._commitData().catch(function (err) {
          log.error('error committing data', err);
        });
      }
    }
    /**
     * Add modified peer key to the dirty set
     *
     * @private
     * @param {Object} params
     * @param {PeerId} params.peerId
     */

  }, {
    key: "_addDirtyPeerKey",
    value: function _addDirtyPeerKey(_ref3) {
      var peerId = _ref3.peerId;

      // Not add if inline key available
      if (peerId.hasInlinePublicKey()) {
        return;
      }

      var peerIdstr = peerId.toB58String();
      log('add dirty peer key', peerIdstr);

      this._dirtyPeers.add(peerIdstr);

      if (this._dirtyPeers.size >= this.threshold) {
        // Commit current data
        this._commitData().catch(function (err) {
          log.error('error committing data', err);
        });
      }
    }
    /**
     * Add modified metadata peer to the set.
     *
     * @private
     * @param {Object} params
     * @param {PeerId} params.peerId
     * @param {string} params.metadata
     */

  }, {
    key: "_addDirtyPeerMetadata",
    value: function _addDirtyPeerMetadata(_ref4) {
      var peerId = _ref4.peerId,
          metadata = _ref4.metadata;
      var peerIdstr = peerId.toB58String();
      log('add dirty metadata peer', peerIdstr);

      this._dirtyPeers.add(peerIdstr); // Add dirty metadata key


      var mData = this._dirtyMetadata.get(peerIdstr) || new Set();
      mData.add(metadata);

      this._dirtyMetadata.set(peerIdstr, mData);

      if (this._dirtyPeers.size >= this.threshold) {
        // Commit current data
        this._commitData().catch(function (err) {
          log.error('error committing data', err);
        });
      }
    }
    /**
     * Add all the peers current data to a datastore batch and commit it.
     *
     * @private
     * @returns {Promise<void>}
     */

  }, {
    key: "_commitData",
    value: function () {
      var _commitData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var commitPeers, batch, _i, _commitPeers, peerIdStr, peerId;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commitPeers = Array.from(this._dirtyPeers);

                if (commitPeers.length) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                // Clear Dirty Peers set
                this._dirtyPeers.clear();

                log('create batch commit');
                batch = this._datastore.batch();

                for (_i = 0, _commitPeers = commitPeers; _i < _commitPeers.length; _i++) {
                  peerIdStr = _commitPeers[_i];
                  // PeerId
                  peerId = this.keyBook.data.get(peerIdStr) || PeerId.createFromB58String(peerIdStr); // Address Book

                  this._batchAddressBook(peerId, batch); // Key Book


                  !peerId.hasInlinePublicKey() && this._batchKeyBook(peerId, batch); // Metadata Book

                  this._batchMetadataBook(peerId, batch); // Proto Book


                  this._batchProtoBook(peerId, batch);
                }

                _context3.next = 9;
                return batch.commit();

              case 9:
                log('batch committed');

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _commitData() {
        return _commitData2.apply(this, arguments);
      }

      return _commitData;
    }()
    /**
     * Add address book data of the peer to the batch.
     *
     * @private
     * @param {PeerId} peerId
     * @param {Batch} batch
     */

  }, {
    key: "_batchAddressBook",
    value: function _batchAddressBook(peerId, batch) {
      var b32key = peerId.toString();
      var key = new Key("".concat(NAMESPACE_ADDRESS).concat(b32key));
      var entry = this.addressBook.data.get(peerId.toB58String());

      try {
        // Deleted from the book
        if (!entry) {
          batch.delete(key);
          return;
        }

        var encodedData = Addresses.encode({
          addrs: entry.addresses.map(function (address) {
            return {
              multiaddr: address.multiaddr.bytes,
              isCertified: address.isCertified
            };
          }),
          certifiedRecord: entry.record ? {
            seq: entry.record.seqNumber,
            raw: entry.record.raw
          } : undefined
        }).finish();
        batch.put(key, encodedData);
      } catch (err) {
        log.error(err);
      }
    }
    /**
     * Add Key book data of the peer to the batch.
     *
     * @private
     * @param {PeerId} peerId
     * @param {Batch} batch
     */

  }, {
    key: "_batchKeyBook",
    value: function _batchKeyBook(peerId, batch) {
      var b32key = peerId.toString();
      var key = new Key("".concat(NAMESPACE_KEYS).concat(b32key));

      try {
        // Deleted from the book
        if (!peerId.pubKey) {
          batch.delete(key);
          return;
        }

        var encodedData = peerId.marshalPubKey();
        batch.put(key, encodedData);
      } catch (err) {
        log.error(err);
      }
    }
    /**
     * Add metadata book data of the peer to the batch.
     *
     * @private
     * @param {PeerId} peerId
     * @param {Batch} batch
     */

  }, {
    key: "_batchMetadataBook",
    value: function _batchMetadataBook(peerId, batch) {
      var _this2 = this;

      var b32key = peerId.toString();
      var dirtyMetada = this._dirtyMetadata.get(peerId.toB58String()) || [];

      try {
        dirtyMetada.forEach(function (
        /** @type {string} */
        dirtyKey) {
          var key = new Key("".concat(NAMESPACE_METADATA).concat(b32key, "/").concat(dirtyKey));

          var dirtyValue = _this2.metadataBook.getValue(peerId, dirtyKey);

          if (dirtyValue) {
            batch.put(key, dirtyValue);
          } else {
            batch.delete(key);
          }
        });
      } catch (err) {
        log.error(err);
      }
    }
    /**
     * Add proto book data of the peer to the batch.
     *
     * @private
     * @param {PeerId} peerId
     * @param {Batch} batch
     */

  }, {
    key: "_batchProtoBook",
    value: function _batchProtoBook(peerId, batch) {
      var b32key = peerId.toString();
      var key = new Key("".concat(NAMESPACE_PROTOCOL).concat(b32key));
      var protocols = this.protoBook.get(peerId);

      try {
        // Deleted from the book
        if (!protocols) {
          batch.delete(key);
          return;
        }

        var encodedData = Protocols.encode({
          protocols: protocols
        }).finish();
        batch.put(key, encodedData);
      } catch (err) {
        log.error(err);
      }
    }
    /**
     * Process datastore entry and add its data to the correct book.
     *
     * @private
     * @param {Object} params
     * @param {Key} params.key - datastore key
     * @param {Uint8Array} params.value - datastore value stored
     * @returns {Promise<void>}
     */

  }, {
    key: "_processDatastoreEntry",
    value: function () {
      var _processDatastoreEntry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
        var key, value, keyParts, peerId, decoded;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                key = _ref5.key, value = _ref5.value;
                _context4.prev = 1;
                keyParts = key.toString().split('/');
                peerId = PeerId.createFromBytes(base32.decode(keyParts[3]));
                _context4.t0 = keyParts[2];
                _context4.next = _context4.t0 === 'addrs' ? 7 : _context4.t0 === 'keys' ? 10 : _context4.t0 === 'metadata' ? 15 : _context4.t0 === 'protos' ? 17 : 20;
                break;

              case 7:
                decoded = Addresses.decode(value); // @ts-ignore protected function

                this.addressBook._setData(peerId, {
                  addresses: decoded.addrs.map(function (address) {
                    return {
                      multiaddr: new Multiaddr(address.multiaddr),
                      isCertified: Boolean(address.isCertified)
                    };
                  }),
                  record: decoded.certifiedRecord ? {
                    raw: decoded.certifiedRecord.raw,
                    seqNumber: decoded.certifiedRecord.seq
                  } : undefined
                }, {
                  emit: false
                });

                return _context4.abrupt("break", 21);

              case 10:
                _context4.next = 12;
                return PeerId.createFromPubKey(value);

              case 12:
                decoded = _context4.sent;

                // @ts-ignore protected function
                this.keyBook._setData(decoded, decoded, {
                  emit: false
                });

                return _context4.abrupt("break", 21);

              case 15:
                this.metadataBook._setValue(peerId, keyParts[4], value, {
                  emit: false
                });

                return _context4.abrupt("break", 21);

              case 17:
                decoded = Protocols.decode(value); // @ts-ignore protected function

                this.protoBook._setData(peerId, new Set(decoded.protocols), {
                  emit: false
                });

                return _context4.abrupt("break", 21);

              case 20:
                log('invalid data persisted for: ', key.toString());

              case 21:
                _context4.next = 26;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t1 = _context4["catch"](1);
                log.error(_context4.t1);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 23]]);
      }));

      function _processDatastoreEntry(_x) {
        return _processDatastoreEntry2.apply(this, arguments);
      }

      return _processDatastoreEntry;
    }()
  }]);

  return PersistentPeerStore;
}(PeerStore);

module.exports = PersistentPeerStore;